"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChannelDeletePayload = exports.LatestData = exports.CustomerInformation = exports.DeviceItem = exports.DevicePage = exports.Device = exports.UnitError = exports.UnitAlert = exports.UnitType = exports.CustomerAddress = exports.ListDevicesQuery = exports.GetDeviceQuery = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const Json = __importStar(require("../../../../../json"));
const field_1 = require("../../../openapi/field");
const Registry = __importStar(require("../device/registry/schema"));
const shared_1 = require("../device/shared");
exports.NAMESPACE = 'Culligan.Api.V1.Admin.Greg.Schema';
/*
 * Query structs stay anonymous: Effect only emits query parameters when the
 * top-level JSON Schema exposes `properties` inline (see shared.ts).
 */
/** GET /device/registry and GET /device/data accept only serialNumber. */
exports.GetDeviceQuery = effect_1.Schema.Struct({
    serialNumber: effect_1.Schema.NonEmptyString,
}).annotations({
    identifier: `${exports.NAMESPACE}.GetDeviceQuery`,
});
const FlagTrue = effect_1.Schema.Literal('true');
/*
 * GET /device/registry/list query.
 *
 * Express qs nests `filters[x]` / `page[x]` at runtime. UrlParams schemas must
 * encode to a flat string map, so the bracket keys stay literal property names
 * here (same shape the wire query uses).
 *
 * Top-level serialNumber/name/model/ownerId/dealerId are length-checked when
 * present (min 2) but are not applied to the Cosmos query; only filters and
 * page drive the result set.
 */
exports.ListDevicesQuery = effect_1.Schema.Struct({
    'serialNumber': (0, field_1.optionalString)('Validated when present; not used as a list filter'),
    'name': (0, field_1.optionalString)('Validated when present; not used as a list filter'),
    'model': (0, field_1.optionalString)('Validated when present; not used as a list filter'),
    'ownerId': (0, field_1.optionalString)('Validated when present; not used as a list filter'),
    'dealerId': (0, field_1.optionalString)('Validated when present; not used as a list filter'),
    'filters[accountNumber]': (0, field_1.optionalString)('Dealer account number substring'),
    'filters[customerAddress]': (0, field_1.optionalString)('Accepted by the query parser; runtime no longer filters on customer address'),
    'filters[installationAddress]': (0, field_1.optionalString)('Installation-address substring match'),
    'filters[wifiDSN]': (0, field_1.optionalString)('Device id / serial substring'),
    'filters[dealerNumber]': effect_1.Schema.optionalWith(effect_1.Schema.Union(effect_1.Schema.String, effect_1.Schema.Array(effect_1.Schema.String)), {
        exact: true,
    }).annotations({
        description: 'Dealer id; a single value or repeated query params',
    }),
    'filters[new]': effect_1.Schema.optionalWith(FlagTrue, { exact: true }).annotations({
        description: 'When true, only devices with a non-null ownerId',
    }),
    'filters[email]': (0, field_1.optionalString)('contactInfo.email substring'),
    'filters[phoneNumber]': (0, field_1.optionalString)('contactInfo.phoneNumber substring'),
    'filters[lastName]': (0, field_1.optionalString)('contactInfo.name substring'),
    'filters[customerAccountId]': (0, field_1.optionalString)('contactInfo.customerAccountId substring'),
    'filters[healthReport][saltService]': effect_1.Schema.optionalWith(FlagTrue, { exact: true }),
    'filters[healthReport][filterService]': effect_1.Schema.optionalWith(FlagTrue, { exact: true }),
    'filters[healthReport][annualService]': effect_1.Schema.optionalWith(FlagTrue, { exact: true }),
    'filters[softener][softenerUnitType]': effect_1.Schema.optionalWith(FlagTrue, { exact: true }),
    'filters[ro][roUnitType]': effect_1.Schema.optionalWith(FlagTrue, { exact: true }),
    'filters[filter][filterUnitType]': effect_1.Schema.optionalWith(FlagTrue, { exact: true }),
    'page[current]': effect_1.Schema.optionalWith(shared_1.PositiveIntFromString, { exact: true }).annotations({
        description: 'Page number; defaults to 1',
    }),
    'page[size]': effect_1.Schema.optionalWith(shared_1.PositiveIntFromString, { exact: true }).annotations({
        description: 'Page size; defaults to 1000',
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.ListDevicesQuery`,
});
const customerAddressFields = {
    firstName: (0, field_1.optionalNullableString)('Owner first name'),
    lastName: (0, field_1.optionalNullableString)('Owner last name'),
    email: (0, field_1.optionalNullableString)('Owner email'),
    mobilePhoneNumber: (0, field_1.optionalNullableString)('Owner mobile phone'),
    address: (0, field_1.optionalNullableString)('Street address'),
    addressExtra: (0, field_1.optionalNullableString)('Additional address line'),
    city: (0, field_1.optionalNullableString)('City'),
    state: (0, field_1.optionalNullableString)('State or province'),
    zip: (0, field_1.optionalNullableString)('Postal code'),
    country: (0, field_1.optionalNullableString)('Country'),
};
exports.CustomerAddress = effect_1.Schema.Struct(customerAddressFields).annotations({
    identifier: `${exports.NAMESPACE}.CustomerAddress`,
    description: 'Owner profile projection. Absent keys when no owner profile was loaded; otherwise each field is a string or null.',
});
exports.UnitType = effect_1.Schema.Struct({
    description: effect_1.Schema.String,
    code: effect_1.Schema.NullOr(effect_1.Schema.Union(effect_1.Schema.Number, effect_1.Schema.String)),
}).annotations({
    identifier: `${exports.NAMESPACE}.UnitType`,
    description: 'Derived unit type; SRO models store the model code in code',
});
exports.UnitAlert = effect_1.Schema.Struct({
    description: effect_1.Schema.String,
}).annotations({
    identifier: `${exports.NAMESPACE}.UnitAlert`,
});
exports.UnitError = effect_1.Schema.Struct({
    description: effect_1.Schema.String,
    code: effect_1.Schema.Number,
}).annotations({
    identifier: `${exports.NAMESPACE}.UnitError`,
});
/*
 * Properties kept by postFormatDeviceRecords (PROPERTY_FIELDS). Keys stay
 * optional: devices omit the bag entirely when Cosmos has no properties.
 */
const DeviceProperties = effect_1.Schema.Struct({
    annual_service_counter: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(Json.Value), { exact: true }),
    manual_salt_level_rem_calc: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(Json.Value), { exact: true }),
    days_salt_remaining: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(Json.Value), { exact: true }),
    battery_installed: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(Json.Value), { exact: true }),
    system_error_bit_flags: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(Json.Value), { exact: true }),
    accessories_enable_bit_flags: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(Json.Value), { exact: true }),
    away_mode: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(Json.Value), { exact: true }),
    warning_filter: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(Json.Value), { exact: true }),
    warning_media: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(Json.Value), { exact: true }),
    warning_leak: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(Json.Value), { exact: true }),
    remaining_capacity_percentage: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(Json.Value), { exact: true }),
    installation_date: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(Json.Value), { exact: true }),
    hardware_version: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(Json.Value), { exact: true }),
    critical_errors: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(Json.Value), { exact: true }),
    non_critical_errors: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(Json.Value), { exact: true }),
    salt_level_low: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(Json.Value), { exact: true }),
    percent_salt_remaining: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(Json.Value), { exact: true }),
    system_warning_bit_flags: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(Json.Value), { exact: true }),
});
const recordTimestamp = (description) => effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.Union((0, field_1.dateTime)(description), effect_1.Schema.Number)), { exact: true }).annotations({
    description,
});
exports.Device = effect_1.Schema.Struct({
    serialNumber: (0, field_1.nonEmpty)('Device serial number (from id when serialNumber was absent)'),
    name: (0, field_1.optionalNullableString)('Device display name'),
    ownerId: (0, field_1.optionalNullableString)('Owner user id'),
    dealerId: (0, field_1.optionalNullableString)('Dealer id'),
    tenantId: (0, field_1.optionalNullableString)('Tenant id'),
    model: (0, field_1.optionalNullableString)('Legacy model code'),
    lat: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.Number), { exact: true }),
    lon: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.Number), { exact: true }),
    region: (0, field_1.optionalNullableString)('Macro-region code projected from region.code'),
    registrationToken: (0, field_1.optionalNullableString)('Registration token'),
    protocolVersion: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.Number), { exact: true }),
    swVersion: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(Json.Value), { exact: true }),
    status: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(Json.Record), { exact: true }).annotations({
        description: 'Connection status bag; defaults to offline when missing on the stored record',
    }),
    properties: effect_1.Schema.optionalWith(DeviceProperties, { exact: true }).annotations({
        description: 'Allow-listed telemetry properties only',
    }),
    metaData: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(Json.Record), { exact: true }),
    accountNumber: (0, field_1.optionalNullableString)('Dealer account number'),
    installationAddress: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(Registry.InstallationAddress), { exact: true }),
    contactInfo: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(Registry.ContactInfo), { exact: true }),
    createdAt: recordTimestamp('Creation time'),
    registeredAt: recordTimestamp('Registration time'),
    updatedAt: recordTimestamp('Last update time'),
    customerName: (0, field_1.optionalNullableString)('Owner full name, or null when no owner profile'),
    customerFullAddress: (0, field_1.optionalNullableString)('Comma-joined owner address, empty string or null when no owner profile'),
    customerAddress: effect_1.Schema.optionalWith(exports.CustomerAddress, { exact: true }).annotations({
        description: 'Owner address bag; empty object when no owner profile was loaded',
    }),
    unitType: effect_1.Schema.optionalWith(exports.UnitType, { exact: true }),
    unitAlerts: effect_1.Schema.optionalWith(effect_1.Schema.Array(exports.UnitAlert), { exact: true }),
    unitErrors: effect_1.Schema.optionalWith(effect_1.Schema.Array(exports.UnitError), { exact: true }),
}).annotations({
    identifier: `${exports.NAMESPACE}.Device`,
    description: 'GREG device registry projection',
});
exports.DevicePage = effect_1.Schema.Struct({
    items: effect_1.Schema.Array(exports.Device),
    page: effect_1.Schema.propertySignature(effect_1.Schema.Union(effect_1.Schema.String, effect_1.Schema.Int.pipe(effect_1.Schema.positive()))).annotations({
        description: 'Echo of page[current] when the query sends it (string). Numeric 1 when the query omits it.',
    }),
    itemsCount: effect_1.Schema.Int.pipe(effect_1.Schema.nonNegative()),
    pagesCount: effect_1.Schema.Int.pipe(effect_1.Schema.positive()),
    provider: effect_1.Schema.optionalWith(Json.Record, { exact: true }).annotations({
        description: 'Engine pagination metadata, when present',
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.DevicePage`,
});
exports.DeviceItem = effect_1.Schema.Struct({
    item: effect_1.Schema.optionalWith(exports.Device, { exact: true }).annotations({
        description: 'Matching device; omitted or undefined when the serial number is not visible',
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.DeviceItem`,
    description: 'GET /device/registry success envelope data',
});
exports.CustomerInformation = effect_1.Schema.Struct({
    userId: (0, field_1.nonEmpty)('Owner user id'),
    customerFullAddress: effect_1.Schema.String,
    customerAddress: exports.CustomerAddress,
    country: effect_1.Schema.NullOr(effect_1.Schema.String),
    accountNumber: effect_1.Schema.NullOr(effect_1.Schema.String),
    lastName: effect_1.Schema.NullOr(effect_1.Schema.String),
    firstName: effect_1.Schema.NullOr(effect_1.Schema.String),
    phone: effect_1.Schema.NullOr(effect_1.Schema.String),
    email: effect_1.Schema.NullOr(effect_1.Schema.String),
}).annotations({
    identifier: `${exports.NAMESPACE}.CustomerInformation`,
    description: 'Owner profile attached to GET /device/data when the device has an ownerId',
});
exports.LatestData = effect_1.Schema.Struct({
    datapoints: Json.Record,
    lastUpdate: effect_1.Schema.NullOr((0, field_1.dateTime)('ISO-8601 last datapoint time')),
    customerInformation: effect_1.Schema.optionalWith(exports.CustomerInformation, { exact: true }),
}).annotations({
    identifier: `${exports.NAMESPACE}.LatestData`,
    description: 'Latest datapoints plus optional owner profile',
});
exports.ChannelDeletePayload = effect_1.Schema.Struct({
    channelId: (0, field_1.nonEmpty)('Notification channel id'),
    userId: (0, field_1.nonEmpty)('Owner user id required by the GREG wrapper'),
}).annotations({
    identifier: `${exports.NAMESPACE}.ChannelDeletePayload`,
    description: 'GREG delete channel; userId is required even though the frontend service ignores it',
});
//# sourceMappingURL=schema.js.map